import {
  formatRecommendedArtworkPrice,
  getRecommendedArtworkArtistName,
  getRecommendedArtworkPricingAmount,
  getRecommendedArtworkTitle,
  resolveRecommendedArtworkImageUrl,
} from '@/utils/aiRecommendedArtworks';

export default function AiRecommendArtworkCard({ artwork, onClick }) {
  const title = getRecommendedArtworkTitle(artwork);
  const artistName = getRecommendedArtworkArtistName(artwork);
  const imageUrl = resolveRecommendedArtworkImageUrl(artwork);
  const pricingAmount = getRecommendedArtworkPricingAmount(artwork);
  const priceLabel = formatRecommendedArtworkPrice(pricingAmount, artwork?.artwork_about?.artwork_currency);

  return (
    <button
      type="button"
      className="artwork-view-ai__recommendation-card"
      onClick={onClick}
    >
      <div className="artwork-view-ai__recommendation-media">
        {imageUrl ? (
          <img
            className="artwork-view-ai__recommendation-image"
            src={imageUrl}
            alt={title}
            loading="lazy"
          />
        ) : (
          <div className="artwork-view-ai__recommendation-placeholder" aria-hidden="true" />
        )}
      </div>
      <div className="artwork-view-ai__recommendation-body">
        <p className="artwork-view-ai__recommendation-title">{title}</p>
        <p className="artwork-view-ai__recommendation-artist">{artistName}</p>
        {priceLabel ? (
          <p className="artwork-view-ai__recommendation-price">
            {artwork?.artwork_about?.artwork_is_auction ? `Bid ${priceLabel}` : priceLabel}
          </p>
        ) : null}
      </div>
    </button>
  );
}
